import React from 'react';
import PropTypes from 'prop-types';
import FormikInput from "../../../../../../components/input/new/FormikInput";

SenderCityZipCodeField.propTypes = {

};

function SenderCityZipCodeField() {
    return (
        <FormikInput
            name={"senderCityZipCode"}
            label={"shippingMethods.form.field.senderCityZipCode.label"}
            placeholder={"shippingMethods.form.field.senderCityZipCode.placeholder"}
            required={true}
        />
    );
}

export default SenderCityZipCodeField;